import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { MyProvider } from "./context/StoreContext";
import AuthContextProvider from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import { PropertyProvider } from "./context/PropertyContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <>
        {/* <React.StrictMode> */}
        <MyProvider>
            <AuthContextProvider>
                <PropertyProvider>
                    <Router>
                            <ToastContainer autoClose={2000} />
                            <App />
                    </Router>
                </PropertyProvider>
            </AuthContextProvider>
        </MyProvider>
        {/* </React.StrictMode> */}
    </>
);

reportWebVitals();
